import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router';
import TabbedPage from 'components/TabbedPage';
import ControlPanel from 'components/Meteorology/Weather/ControlPanel';
import RightSidebar from 'components/Layout/RightSidebar';
import MobileSectionHeader from 'components/Layout/MobileShell/MobileSectionHeader';
import SectionTabs, { SectionTabItem } from 'components/Layout/MobileShell/SectionTabs';
import MoreSheet from 'components/Layout/MobileShell/MoreSheet';
import useIsMobile from 'utils/hooks/useIsMobile';
import shortenedTabPath from 'helper/shortenedTabPath';
import { openRight } from 'redux/reducers/sidebarsReducer';

const MOBILE_TABS: SectionTabItem[] = [
  { title: 'Oscilações', path: '/meteorology/weather/oscillations/' },
  { title: 'Previsão Sazonal', path: '/meteorology/weather/seasonal-forecast' },
  { title: 'Comparador', path: '/meteorology/weather/comparator' },
  { title: 'Similaridade', path: '/meteorology/weather/similarity' },
];

export default function WeatherLayout() {
  const [showSidebar, setShowSidebar] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [moreOpen, setMoreOpen] = useState(false);

  useEffect(() => {
    dispatch(openRight());
  }, [dispatch]);

  if (isMobile) {
    const activeTab = MOBILE_TABS.find(
      (tab) => tab.path === shortenedTabPath(location.pathname),
    );

    return (
      <>
        <MobileSectionHeader
          backLabel="Clima"
          title={activeTab?.title ?? ''}
          onBack={() => navigate('/meteorology')}
          onAvatarClick={() => setMoreOpen(true)}
        />
        <SectionTabs tabs={MOBILE_TABS} />
        <Outlet />
        <MoreSheet open={moreOpen} dismiss={() => setMoreOpen(false)} />
      </>
    );
  }

  return (
    <>
      <Row>
        <Col className="md-6">
          <h1 className="mb-3">CLIMA</h1>
        </Col>
      </Row>
      <Row style={{ flexWrap: 'nowrap', paddingBottom: '3.3125rem' }}>
        <Col xs="auto" className="flex-fill overflow-hidden">
          <TabbedPage setControlPanelVisibility={setShowSidebar}>
            <TabbedPage.Tab title="OSCILAÇÕES" path="/meteorology/weather/oscillations/" />
            <TabbedPage.Tab
              title="PREVISÃO SAZONAL"
              path="/meteorology/weather/seasonal-forecast"
              showControlPanel
            />
            <TabbedPage.Tab
              title="COMPARADOR"
              path="/meteorology/weather/comparator"
              showControlPanel
            />
            <TabbedPage.Tab
              title="SIMILARIDADE"
              path="/meteorology/weather/similarity"
              showControlPanel
            />
          </TabbedPage>
        </Col>
        {showSidebar && (
          <Col xs="auto">
            <RightSidebar>
              <ControlPanel />
            </RightSidebar>
          </Col>
        )}
      </Row>
      <div className="bottom-bar" />
    </>
  );
}
